import { render, staticRenderFns } from "./QEventsLeaderboardDataTable.vue?vue&type=template&id=60a40ff6&"
import script from "./QEventsLeaderboardDataTable.vue?vue&type=script&lang=js&"
export * from "./QEventsLeaderboardDataTable.vue?vue&type=script&lang=js&"
import style0 from "./QEventsLeaderboardDataTable.vue?vue&type=style&index=0&id=60a40ff6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports